(() => {
  const root = document.body.dataset.root || '/';
  const messages = JSON.parse(document.querySelector('#wr-messages')?.textContent || '{}');
  let busy = false;
  let toastTimer;
  let lastCartTrigger;
  const bundle = new Map();
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:document.body.dataset.currency || 'USD',minimumFractionDigits:0,maximumFractionDigits:2}).format(cents / 100);
  function toast(message) {
    const node = document.querySelector('.wr-toast');
    if (!node) return;
    node.textContent = message;
    node.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => node.hidden = true, 6000);
  }
  let drawerMotion;
  let drawerClosing=false;
  const drawerTiming={duration:250,easing:'cubic-bezier(0.4,0,0.2,1)'};
  function openCart() {
    const dialog = document.querySelector('#WrCart');
    if (!dialog || dialog.open) return;
    lastCartTrigger = document.activeElement;
    dialog.classList.remove('is-closing');
    dialog.showModal();
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches){
      drawerMotion=dialog.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}],drawerTiming);
    }
  }
  function closeCart() {
    const dialog=document.querySelector('#WrCart');
    if(!dialog?.open||drawerClosing)return;
    drawerClosing=true;
    const finish=()=>{dialog.close();dialog.classList.remove('is-closing');drawerClosing=false;if(lastCartTrigger?.isConnected)lastCartTrigger.focus();};
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){finish();return;}
    const position=getComputedStyle(dialog).transform;
    drawerMotion?.cancel();
    dialog.classList.add('is-closing');
    drawerMotion=dialog.animate([{transform:position},{transform:'translateX(100%)'}],drawerTiming);
    drawerMotion.finished.then(finish,finish);
  }
  document.querySelector('#WrCart')?.addEventListener('cancel',event=>{event.preventDefault();closeCart();});
  function renderCart(html) {
    if (!html) return false;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#WrCart');
    const current = document.querySelector('#WrCart');
    if (!fresh || !current) return false;
    const priorRows=new Map(Array.from(current.querySelectorAll('.wr-cart-item')).map(row=>[row.querySelector('a')?.getAttribute('href'),row.getBoundingClientRect().top]));
    const oldScroll=current.querySelector('.wr-cart-scroll')?.scrollTop||0;
    const oldMeter=current.querySelector('.wr-shipping-meter');
    const oldFill=oldMeter?.querySelector('span');
    const previousFill=oldFill&&oldMeter.clientWidth?oldFill.getBoundingClientRect().width/oldMeter.clientWidth*100:0;
    current.innerHTML = fresh.innerHTML;
    const nextFill=current.querySelector('.wr-shipping-meter span');
    if(nextFill&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
      const target=nextFill.style.width;
      nextFill.style.width=previousFill+'%';
      void nextFill.offsetWidth;
      requestAnimationFrame(()=>{if(nextFill.isConnected)nextFill.style.width=target;});
    }
    current.dataset.cartCount = fresh.dataset.cartCount;
    const scrollArea=current.querySelector('.wr-cart-scroll');
    if(scrollArea)scrollArea.scrollTop=oldScroll;
    if(current.open&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
      current.querySelectorAll('.wr-cart-item').forEach(row=>{
        const previous=priorRows.get(row.querySelector('a')?.getAttribute('href'));
        const offset=previous===undefined?12:previous-row.getBoundingClientRect().top;
        row.animate([{opacity:previous===undefined?0:1,transform:'translateY('+offset+'px)'},{opacity:1,transform:'translateY(0)'}],{duration:280,easing:'cubic-bezier(.4,0,.2,1)'});
      });
    }
    
    document.querySelectorAll('[data-cart-count]').forEach(node => {
      if (node !== current) node.textContent = Number(fresh.dataset.cartCount) ? `(${fresh.dataset.cartCount})` : '';
    });
    return true;
  }
  let cartRevision=0;
  let cartRefresh;
  async function refreshCart() {
    if(cartRefresh)return cartRefresh;
    const revision=cartRevision;
    cartRefresh=(async()=>{
    const response=await fetch(`${root}?sections=wr-cart&_wr=${Date.now()}`,{credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error(messages.error);
    const data = await response.json();
    if(revision!==cartRevision)return;
    if (!renderCart(data['wr-cart'])) throw new Error(messages.error);
    })();
    try{await cartRefresh;}finally{cartRefresh=null;}
  }
  function syncVisibleCart(){if(document.visibilityState==='visible'&&!busy)refreshCart().catch(()=>{});}
  window.addEventListener('pageshow',syncVisibleCart);
  document.addEventListener('visibilitychange',syncVisibleCart);
  window.addEventListener('focus',syncVisibleCart);
  async function mutateCart(path, payload, trigger) {
    if (busy) return false;
    busy = true;
    cartRevision++;
    const wasDisabled = trigger?.disabled;
    if (trigger) {trigger.disabled = true; trigger.setAttribute('aria-busy','true');}
    try {
      const response = await fetch(root + path, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify({...payload,sections:['wr-cart'],sections_url:location.pathname})});
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        await refreshCart().catch(() => {});
        throw new Error(typeof data.description === 'string' ? data.description : messages.error);
      }
      const addon=trigger?.closest('.wr-addon');
      if(addon&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
        trigger.removeAttribute('aria-busy');
        trigger.textContent='✓';
        trigger.setAttribute('aria-label','Item added');
        await addon.animate([{opacity:1,transform:'translateY(0)'},{opacity:0,transform:'translateY(-6px)'}],{duration:280,easing:'cubic-bezier(.4,0,.2,1)',fill:'forwards'}).finished;
      }
      if (!renderCart(data.sections?.['wr-cart'])) await refreshCart();
      openCart();
      return true;
    } catch (error) {
      toast(error.message || messages.error);
      return false;
    } finally {
      busy = false;
      if (trigger?.isConnected) {trigger.disabled = Boolean(wasDisabled); trigger.removeAttribute('aria-busy');}
    }
  }
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-cart-open]');
    if (open) {event.preventDefault(); try{await refreshCart();}catch(error){toast(error.message||messages.error);} openCart(); return;}
    if (event.target.closest('[data-cart-close]')) {closeCart(); return;}
    const add = event.target.closest('[data-add-variant]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      if (!add.disabled) {
        const sizeGroup=add.closest('.wr-quick-sizes,.wr-addon-sizes');
        if(sizeGroup){sizeGroup.querySelectorAll('.is-size-chosen').forEach(button=>button.classList.remove('is-size-chosen'));add.classList.add('is-size-chosen');}
        const added=await mutateCart('cart/add.js',{items:[{id:Number(add.dataset.addVariant),quantity:1}]},add);
        if(!added) add.classList.remove('is-size-chosen');
      }
      return;
    }
    const change = event.target.closest('[data-cart-change]');
    if (change) {await mutateCart('cart/change.js',{id:change.dataset.cartChange,quantity:Number(change.dataset.quantity)},change); return;}
    const bundleButton = event.target.closest('[data-bundle-add]');
    if (bundleButton) {
      if (bundle.size < 2) {toast(messages.bundle_empty); return;}
      const items = Array.from(bundle.values()).map(item => ({id:item.id,quantity:1}));
      const added = await mutateCart('cart/add.js',{items},bundleButton);
      if (added) {
        bundle.clear();
        document.querySelectorAll('[data-bundle-select]').forEach(select => {select.value=''; select.closest('.wr-card').classList.remove('is-selected');});
        updateBundle();
      }
      return;
    }

    if (!event.target.closest('.wr-menu')) document.querySelectorAll('.wr-menu[open]').forEach(menu => menu.open=false);
  });
  document.addEventListener('click', event => {
    const dialog = document.querySelector('#WrCart');
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeCart();
    }
  });
  document.addEventListener('keydown', event => {if (event.key === 'Escape') document.querySelectorAll('.wr-menu[open]').forEach(menu => menu.open=false);});
  function updateBundle() {
    const count = bundle.size;
    document.querySelector('[data-bundle-count]')?.replaceChildren(document.createTextNode(count));
    document.querySelector('[data-bundle-total]')?.replaceChildren(document.createTextNode(money(Array.from(bundle.values()).reduce((sum,item)=>sum+item.price,0))));
    const button = document.querySelector('[data-bundle-add]');
    if (button) button.disabled=count<2;
  }
  document.addEventListener('change', event => {
    const select=event.target.closest('[data-bundle-select]');
    if (select) {
      if (select.value) bundle.set(select.dataset.productId,{id:Number(select.value),price:Number(select.selectedOptions[0].dataset.price)});
      else bundle.delete(select.dataset.productId);
      select.closest('.wr-card').classList.toggle('is-selected',Boolean(select.value));
      updateBundle();
    }
  });
  function initProducts(scope=document) {
    scope.querySelectorAll('[data-product-root]').forEach(product => {
      if (product.dataset.initialized) return;
      product.dataset.initialized='true';
      const variants=JSON.parse(product.querySelector('[data-product-variants]').textContent);
      const groups=Array.from(product.querySelectorAll('[data-option-index]'));
      const submit=product.querySelector('[data-product-submit]');
      const input=product.querySelector('[data-variant-id]');
      input.disabled=false;
      const labels=JSON.parse(product.querySelector('[data-option-labels]')?.textContent || '[]');
      groups.forEach((group,index)=>{if(labels[index])group.querySelector('legend').textContent=labels[index];});
      function update() {
        const selected=groups.map(group=>group.querySelector('input:checked')?.value);
        groups.forEach((group,index)=>group.querySelectorAll('input').forEach(radio=>{
          const available=variants.some(variant=>variant.available && variant.options[index]===radio.value && selected.every((value,other)=>other===index||!value||variant.options[other]===value));
          radio.disabled=!available;
        }));
        const variant=variants.find(variant=>selected.every((value,index)=>value&&variant.options[index]===value));
        if (!groups.length) return;
        input.value=variant?.id || '';
        submit.disabled=!variant?.available;
        submit.textContent=variant?(variant.available?messages.add_cart:messages.sold):(variants.some(v=>v.available)?messages.select:messages.sold);
        if (variant) {
          product.querySelector('[data-product-price]').textContent=money(variant.price);
          const compare=product.querySelector('[data-product-compare]');
          if(compare){compare.hidden=!(variant.compare_at_price>variant.price);compare.textContent=compare.hidden?'':money(variant.compare_at_price);}
          const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
          if (variant.featured_media) {
            const slide=product.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
            const track=product.querySelector('.wr-gallery-track');
            if (slide) track.scrollTo({left:slide.offsetLeft-track.offsetLeft,behavior:'smooth'});
          }
        }
      }
      product.addEventListener('change',event=>{if(event.target.matches('[data-option-value]'))update();});
      const selectedId=new URL(location.href).searchParams.get('variant');
      if (selectedId) {
        const variant=variants.find(v=>String(v.id)===selectedId);
        if (variant) groups.forEach((group,index)=>group.querySelectorAll('input').forEach(radio=>radio.checked=radio.value===variant.options[index]));
      }
      update();
      product.querySelector('[data-wr-product-form]')?.addEventListener('submit',async event=>{
        event.preventDefault();
        if(submit.disabled||!input.value)return;
        await mutateCart('cart/add.js',{items:[{id:Number(input.value),quantity:1}]},submit);
      });
      const track=product.querySelector('.wr-gallery-track');
      const bar=product.querySelector('.wr-gallery-progress span');
      const galleryMeter=product.querySelector('.wr-gallery-progress');
      const galleryMax=()=>Math.max(0,track.scrollWidth-track.clientWidth);
      const connection=navigator.connection;
      const constrained=connection?.saveData||/2g|3g/.test(connection?.effectiveType||'');
      function hydrateSlide(index){
        const template=track.children[index]?.querySelector('template[data-gallery-image]');
        if(template)template.replaceWith(template.content.cloneNode(true));
      }
      const warmedSlides=new Set();
      function warmNext(index){
        if(constrained||warmedSlides.has(index))return;
        warmedSlides.add(index);
        const image=track.children[index]?.querySelector('img');
        const warm=()=>{const run=()=>hydrateSlide(index+1);if('requestIdleCallback' in window)requestIdleCallback(run,{timeout:1500});else setTimeout(run,250);};
        if(image?.complete)warm();else image?.addEventListener('load',warm,{once:true});
      }

      function updateGalleryFill(){
        const max=galleryMax();
        const total=Math.max(1,track.children.length);
        const index=max?Math.max(0,Math.min(total-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth)))):0;
        hydrateSlide(index);
        if(!track.dataset.ratioLocked){
          const firstImage=track.children[0]?.querySelector('img');
          const width=Number(firstImage?.getAttribute('width'));
          const height=Number(firstImage?.getAttribute('height'));
          if(width&&height){track.style.setProperty('--wr-gallery-ratio',String(width/height));track.dataset.ratioLocked='true';}
        }
        warmNext(index);
        const progress=total>1?Math.round(index/(total-1)*100):0;
        if(bar)bar.style.width=progress+'%';
        if(galleryMeter)galleryMeter.setAttribute('aria-valuenow',String(Math.round(progress)));
      }
      let pointerStart;
      let touchStart=null;
      track.addEventListener('touchstart',event=>{if(event.touches.length===1)touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY,at:track.scrollLeft};},{passive:true});
      track.addEventListener('touchend',event=>{
        if(!touchStart||!event.changedTouches.length)return;
        const dx=event.changedTouches[0].clientX-touchStart.x;
        const dy=event.changedTouches[0].clientY-touchStart.y;
        const started=touchStart;touchStart=null;
        if(Math.abs(dx)<35||Math.abs(dx)<Math.abs(dy))return;
        if(dx<0&&started.at>=galleryMax()-3)advanceGallery(1);
        if(dx>0&&started.at<=3)advanceGallery(-1);
      },{passive:true});
      track.addEventListener('wheel',event=>{
        if(Math.abs(event.deltaX)<=Math.abs(event.deltaY))return;
        const atEdge=event.deltaX>0?track.scrollLeft>=galleryMax()-3:track.scrollLeft<=3;
        if(atEdge&&galleryMax()>0){event.preventDefault();advanceGallery(Math.sign(event.deltaX));}
      },{passive:false});
      let suppressClickUntil=0;
      const advanceGallery=(direction=1)=>{
        const count=track.children.length;
        if(count<2||!track.clientWidth)return;
        const current=Math.round(track.scrollLeft/track.clientWidth);
        const next=(current+direction+count)%count;
        hydrateSlide(next);
        track.scrollTo({left:next*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      };
      track.addEventListener('pointerdown',event=>{pointerStart={x:event.clientX,y:event.clientY};},{passive:true});
      track.addEventListener('pointerup',event=>{
        if(pointerStart&&Math.hypot(event.clientX-pointerStart.x,event.clientY-pointerStart.y)>12)suppressClickUntil=Date.now()+500;
        pointerStart=null;
      },{passive:true});
      track.addEventListener('pointercancel',()=>{pointerStart=null;suppressClickUntil=Date.now()+500;},{passive:true});
      track.addEventListener('click',event=>{
        if(!event.target.closest('[data-gallery-advance]')||Date.now()<suppressClickUntil)return;
        advanceGallery();
      });
      track.addEventListener('keydown',event=>{
        if(!['ArrowLeft','ArrowRight'].includes(event.key)||event.target.closest('video,iframe,model-viewer'))return;
        event.preventDefault();advanceGallery(event.key==='ArrowLeft'?-1:1);
      });
      let galleryFrame=false;
      track?.addEventListener('scroll',()=>{if(!galleryFrame){galleryFrame=true;requestAnimationFrame(()=>{galleryFrame=false;updateGalleryFill();});}},{passive:true});
      window.addEventListener('resize',updateGalleryFill,{passive:true});
      updateGalleryFill();
    });
  }
  initProducts();
  document.addEventListener('shopify:section:load',event=>initProducts(event.target));

})();

(function(){
 if(!document.body.classList.contains('template-product'))return;
 const menu=document.querySelector('.wr-menu');if(!menu)return;
 const nav=menu.querySelector('nav');let scheduled=false;
 function contrast(){scheduled=false;if(!menu.open){menu.classList.remove('wr-menu-on-copy');return;}
 const box=nav.getBoundingClientRect();
 const overlaps=[...document.querySelectorAll('.wr-product-info h1,.wr-product-info summary,.wr-product-info .wr-richtext,.wr-product-options,.wr-product-submit,.wr-footer,.wr-related')].some(function(el){const r=el.getBoundingClientRect();return r.width>0&&r.height>0&&r.left<box.right&&r.right>box.left&&r.top<box.bottom&&r.bottom>box.top;});
 menu.classList.toggle('wr-menu-on-copy',overlaps);
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(contrast);}}
 menu.addEventListener('toggle',schedule);window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);
})();
